// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { ContractState, ContractViewModel, ContractsFilter, ContractsGrouping } from '@ail/contracts-api'
import { TenantViewModel } from '@ail/customers-api'
import { OrdersFormViewModel } from '@ail/orders-api'
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Colors,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import React, { Component } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { ConnectedProps, connect } from 'react-redux'
import { NavLink, RouteComponentProps } from 'react-router-dom'
import { Arr } from '../../helpers/Arr'
import { FrontendSettings } from '../../helpers/FrontendSettings'
import { getFormTitle } from '../../helpers/Orders'
import { WithVehicleOrderStats, withVehicleOrderStats } from '../../hooks/useOrderStats'
import { wrapQuery } from '../../redux/api/apiQuery'
import { contractsApi } from '../../redux/api/contractsApi'
import { customersApi } from '../../redux/api/customerApi'
import { ordersApi } from '../../redux/api/ordersApi'
import { State } from '../../redux/reducers/initialState'
import { emptyGuid, paletteForMakesCharts, productTypeIdDict } from '../../types/constants'
import { FrontendSettingsKeys } from '../../types/enums'
import { ICustomerViewModel, IDebounceState } from '../../types/interfaces'
import { Orders } from '../../utils/orders'
import Companies from '../GeneralPage/Companies/Companies'
import { LoadingSpinner } from '../common/LoadingSpinner/LoadingSpinner'
import { ContractStatus } from './ContractStatus/ContractStatus'
import './DashBoardComponent.scss'
import DashboardCharts, { BarChart, DoughnutChart } from './DashboardCharts/DashboardCharts'
import LastActivities from './LastActivities/LastActivities'
import { Loader } from '../common/Loader/Loader'

interface IExpandedCounters {
  active: boolean
  initialized: boolean
  expiring: boolean
}

interface ICountersRanges {
  active: number
  initialized: number
  expiring: number
}

const allowedContractStatusesForUser: ContractState[] = [
  ContractState.Closed,
  ContractState.Running,
  ContractState.Terminated,
  ContractState.Extended,
  ContractState.Initialized,
  ContractState.Canceled,
]

const allowedContractStatusesForAdmin: ContractState[] = [
  ContractState.Running,
  ContractState.Extended,
  ContractState.Initialized,
]

const initialData = {
  data: { labels: [], datasets: [] },
  options: {},
}

type DashboardProps = ConnectedProps<typeof connector> &
  WithTranslation &
  RouteComponentProps<{ companyId?: string }> &
  WithVehicleOrderStats

interface IDashBoardState {
  contracts: { items?: ContractViewModel[]; totalCount?: number; customerIds?: string[] }
  expiringContracts: ContractViewModel[]
  orderForms: OrdersFormViewModel[]
  statsByProduct: { [key: string]: { [key: string]: number } }
  statsByVehicleFuelType: { [key: string]: { [key: string]: number } }
  statsByVehicleMake: { [key: string]: { [key: string]: number } }
  counterExpanded: IExpandedCounters
  childrenActiveContractsAmount: number
  childrenInitializedContractsAmount: number
  allCustomersAmount?: number
  customersCalculating: boolean
  treeViewMode: boolean
  orderFormTenantDict: { [id: string]: boolean }
  activeNaturesStats: { [key: string]: number }
  initializedNaturesStats: { [key: string]: number }
  expiringNaturesStats: { [key: string]: number }
  activeNatures: { [key: string]: { [key: string]: number } }
  initializedNatures: { [key: string]: { [key: string]: number } }
  expiringNatures: { [key: string]: { [key: string]: number } }
  groupInFilter?: string
  orderFormsForActions: OrdersFormViewModel[]
  expirationYears: number[]
  statusInFuelType: string
  activeContractsAmount: number
  countersRanges: ICountersRanges
  showAdditionalCharts: boolean
  showChart: boolean
  refreshVehicleChart: boolean
  refreshExpirationChart: boolean
  contractsListLoading: boolean
  statsByExpiration: { [id: string]: { [id: number]: number } }
  totalExpiringFilterWithinDays: string
  filterWithinDaysForContractsList: Date
  contractsToShow: ContractViewModel[] | null
  expandContracts: boolean
  allContractsByExpiration?: number
  expirationLoading: boolean
  activePaths: string[]
  initializedPaths: string[]
  filterWithinDays: string
  prefilteredCustomers: ICustomerViewModel[]
  rawPrefilteredCustomers: ICustomerViewModel[]
  filteredCustomers: ICustomerViewModel[]
  customersForDetailedTreeview: ICustomerViewModel[]
  searchString: string
  orderFormsLoading: boolean
  debounce: IDebounceState
  loading: boolean
  chartsAnimation: boolean
  stateData: DoughnutChart
  productData: BarChart
  expirationData: BarChart
  fuelData: DoughnutChart
  vehicleData: BarChart
  tenants: TenantViewModel[]
}

class DashBoardComponent extends Component<DashboardProps, IDashBoardState> {
  constructor(props: DashboardProps) {
    const future = new Date()
    ChartJS.register(
      CategoryScale,
      LinearScale,
      ArcElement,
      BarElement,
      Colors,
      ChartDataLabels,
      Title,
      Tooltip,
      Legend
    )
    future.setDate(future.getDate() + 90)
    super(props)
    this.filterChange = this.filterChange.bind(this)
    this.fuelTypeFilterChange = this.fuelTypeFilterChange.bind(this)
    this.state = {
      contracts: {},
      expiringContracts: [],
      orderForms: [],
      statsByProduct: {},
      statsByVehicleFuelType: {},
      statsByVehicleMake: {},
      chartsAnimation: true,
      stateData: initialData,
      productData: initialData,
      expirationData: initialData,
      fuelData: initialData,
      vehicleData: initialData,
      activeNatures: {},
      initializedNatures: {},
      expiringNatures: {},
      activeNaturesStats: {},
      initializedNaturesStats: {},
      expiringNaturesStats: {},
      countersRanges: {
        active: 4,
        initialized: 4,
        expiring: 4,
      },
      childrenActiveContractsAmount: 0,
      childrenInitializedContractsAmount: 0,
      allCustomersAmount: undefined,
      customersCalculating: false,
      counterExpanded: FrontendSettings.getObject(FrontendSettingsKeys.countersExpandStatus) || {
        active: false,
        initialized: false,
        expiring: false,
      },
      treeViewMode: false,
      orderFormTenantDict: {},
      orderFormsForActions: [],
      expirationYears: [],
      statusInFuelType: 'RUNNING',
      activeContractsAmount: 0,
      showAdditionalCharts: true,
      showChart: true,
      refreshVehicleChart: false,
      refreshExpirationChart: false,
      orderFormsLoading: false,
      activePaths: [],
      initializedPaths: [],
      contractsListLoading: false,
      loading: false,
      debounce: {
        change: 0,
      },
      searchString: FrontendSettings.get(FrontendSettingsKeys.dashboardSearchString) || '',
      prefilteredCustomers: [],
      rawPrefilteredCustomers: [],
      filteredCustomers: [],
      customersForDetailedTreeview: [],
      totalExpiringFilterWithinDays: FrontendSettings.get(FrontendSettingsKeys.expiringDaysFilter) || '90',
      contractsToShow: [],
      expandContracts: false,
      allContractsByExpiration: undefined,
      expirationLoading: true,
      filterWithinDaysForContractsList: future,
      filterWithinDays: 'All',
      statsByExpiration: {},
      tenants: [],
    }
  }
  componentDidMount() {
    const companyId = this.props.match?.params.companyId
    if (this.props.user?.isInternalUser) {
      this.setState({
        loading: true,
        orderFormsLoading: true,
      })
      this.props.getOrdersForms().then(
        (orderForms) => {
          this.setState({ loading: false, orderFormsLoading: false, orderForms })
        },
        () => {
          this.setState({ loading: false, orderFormsLoading: false })
        }
      )
    }
    if (!companyId) {
      this.setState({
        contractsListLoading: !this.state.contractsListLoading,
        loading: true,
        showChart: true,
      })
      this.props
        .loadExpiringContracts(6, 90)
        .then((expiringContracts) =>
          this.setState({ contractsListLoading: !this.state.contractsListLoading, expiringContracts })
        )
    }

    this.props.getStatsByExpiration().then((statsByExpiration) => {
      this.setState({ statsByExpiration: statsByExpiration ?? {} })
    })

    const { customers } = this.props
    this.getStatsByExpirationForPieChart(true)
    this.props
      .getCustomersStatistics(ContractsGrouping.ByProduct, [ContractState.Running, ContractState.Extended])
      .then((statsByProduct) => {
        this.setState({ statsByProduct })
        this.getStatsByProductForPieChart()
      })
    this.props
      .getCustomersStatistics(ContractsGrouping.ByVehicleNature, [ContractState.Running, ContractState.Extended])
      .then((res) => {
        this.setState({ activeNatures: res })
        this.props
          .getCustomersStatistics(ContractsGrouping.ByVehicleNature, [ContractState.Initialized])
          .then((res2) => {
            this.setState({ initializedNatures: res2 })
            this.props
              .getCustomersStatistics(
                ContractsGrouping.ByVehicleNature,
                [ContractState.Running, ContractState.Extended],
                Number(this.state.totalExpiringFilterWithinDays)
              )
              .then((res3) => {
                this.setState({ expiringNatures: res3 })
              })
          })
      })
    this.props.getCustomersStatistics(ContractsGrouping.ByVehicleMake).then((statsByVehicleMake) => {
      this.setState({ statsByVehicleMake })
      this.getStatsByVehicleMakeForPieChart()
    })
    this.props
      .getCustomersStatistics(ContractsGrouping.ByVehicleFuelType, [ContractState.Running, ContractState.Extended])
      .then((statsByVehicleFuelType) => {
        this.setState({ statsByVehicleFuelType })
        this.getStatsByFuelTypeForPieChart()
      })
    if (this.props.stats) {
      this.getStatsByStateForPieChart()
    }
    if (customers) {
      this.renderCompanies()
    }
  }

  componentDidUpdate(oldProps: DashboardProps, oldState: IDashBoardState) {
    const companyId = this.props.match?.params.companyId
    const {
      filterWithinDays,
      totalExpiringFilterWithinDays,
      stateData,
      vehicleData,
      expirationData,
      searchString,
      prefilteredCustomers,
      debounce,
      groupInFilter,
      filteredCustomers,
      orderFormTenantDict,
      treeViewMode,
    } = this.state
    if (
      this.state.initializedNatures !== oldState.initializedNatures ||
      this.state.expiringNatures !== oldState.expiringNatures ||
      companyId !== oldProps.match.params.companyId ||
      this.state.activePaths !== oldState.activePaths ||
      this.state.contracts !== oldState.contracts
    ) {
      this.natureCalc()
    }
    if (
      this.props.user?.isInternalUser &&
      (groupInFilter !== oldState.groupInFilter || orderFormTenantDict !== oldState.orderFormTenantDict)
    ) {
      this.prepareFormsToRender()
    }

    if (
      treeViewMode !== oldState.treeViewMode ||
      this.state.groupInFilter !== oldState.groupInFilter ||
      this.props.customers !== oldProps.customers
    ) {
      if (treeViewMode && this.props.history.location.pathname.indexOf('treeview') <= -1) {
        this.renderCompaniesTreeviewMode()
      } else {
        this.renderCompanies()
      }
    }
    if (this.state.orderForms !== oldState.orderForms && this.state.orderForms.length > 0) {
      const orderFormTenantDict: { [id: string]: boolean } = {}
      this.state.orderForms.forEach((form) => {
        orderFormTenantDict[form.ownerTenant] = true
      })
      this.setState({
        orderFormTenantDict,
      })

      if (this.props.user?.isInternalUser) {
        this.setState({
          loading: true,
        })
        this.props.loadTenants().then(
          (tenants) => {
            this.setState({ loading: false, tenants })
          },
          () => {
            this.setState({ loading: false })
          }
        )
      }
    }
    if (filteredCustomers !== oldState.filteredCustomers) {
      this.getStatsByStateForPieChart()
      this.getStatsByProductForPieChart()
      this.getStatsByExpirationForPieChart(
        !!this.props.match?.params?.companyId || !!this.state.groupInFilter ? true : false
      )
      this.getStatsByFuelTypeForPieChart()
      this.getStatsByVehicleMakeForPieChart()
    }
    if (this.state.statsByExpiration !== oldState.statsByExpiration) {
      this.getStatsByExpirationForPieChart(true)
    }

    if (this.props.t !== oldProps.t) {
      this.getStatsByFuelTypeForPieChart()
      this.getStatsByStateForPieChart()
      this.getStatsByProductForPieChart()
    }
    if (companyId !== oldProps.match?.params?.companyId) {
      if (!companyId) {
        this.setState({
          contractsListLoading: !this.state.contractsListLoading,
          showChart: true,
        })
        this.props
          .loadExpiringContracts(6, Number(totalExpiringFilterWithinDays))
          .then((expiringContracts) =>
            this.setState({ contractsListLoading: !this.state.contractsListLoading, expiringContracts })
          )
      } else {
        this.setState({ showChart: false })
      }
    }

    if (this.state.expiringContracts !== oldState.expiringContracts && !companyId) {
      this.setState({
        contractsToShow: this.state.expiringContracts,
      })
    }

    if (this.state.activeContractsAmount !== oldState.activeContractsAmount) {
      if ((this.state.showChart === false && this.state.activeContractsAmount > 1) || this.state.showChart === true) {
        this.setState({
          showAdditionalCharts: true,
        })
      }
      if (this.state.showChart === false && this.state.activeContractsAmount <= 1) {
        this.setState({
          showAdditionalCharts: false,
        })
      }
    }

    if (
      (this.state.contracts.items !== oldState.contracts.items && (!!companyId || !!this.state.groupInFilter)) ||
      ((!!companyId || !!this.state.groupInFilter) &&
        totalExpiringFilterWithinDays !== oldState.totalExpiringFilterWithinDays)
    ) {
      const arr: ContractViewModel[] = []
      const future = new Date()
      future.setDate(future.getDate() + Number(this.state.totalExpiringFilterWithinDays))
      this.state.filteredCustomers?.map((el) => {
        if (this.state.contracts?.customerIds?.length && this.state.contracts?.customerIds[0] === el?.id) {
          this.state.contracts?.items?.map((obj) => {
            if (
              (obj.state === ContractState.Running || obj.state === ContractState.Extended) &&
              new Date(obj.endDate).getTime() > new Date().getTime() &&
              new Date(obj.endDate).getTime() <= future.getTime()
            ) {
              arr.push(obj)
            }
          })
        }
      })
      this.setState({
        contractsToShow: arr || null,
      })
    }

    if (
      companyId !== oldProps.match.params.companyId ||
      (this.props.history.location.pathname !== oldProps.location.pathname &&
        companyId === oldProps.match.params.companyId)
    ) {
      this.setState({
        treeViewMode: false,
        searchString: '',
        expirationData: initialData,
        productData: initialData,
        stateData: initialData,
        vehicleData: initialData,
        fuelData: initialData,
        chartsAnimation: true,
      })
      this.renderCompanies()
    }

    if (expirationData !== oldState.expirationData) {
      this.setState({
        refreshExpirationChart: false,
      })
    }

    if (vehicleData !== oldState.vehicleData) {
      this.setState({
        refreshVehicleChart: false,
      })
    }

    if (debounce.change !== oldState.debounce.change) {
      if (prefilteredCustomers.length > 0) {
        const filteredSearch = searchString ? searchString.trim().toLowerCase() : ''
        const filtered = filteredSearch
          ? prefilteredCustomers.filter((c) => {
              return `${c.name} ${c.id} ${c.vatNumber}`.toLowerCase().indexOf(filteredSearch) >= 0
            })
          : [...prefilteredCustomers]
        const sorted = filtered.sort((a, b) => {
          return (a.name || '').localeCompare(b.name || '')
        })
        this.setState({
          filteredCustomers: sorted,
        })
      }
    }

    if (filterWithinDays !== oldState.filterWithinDays) {
      this.getStatsByExpirationForPieChart(false)
    }
    if (
      totalExpiringFilterWithinDays !== oldState.totalExpiringFilterWithinDays ||
      (this.state.groupInFilter !== oldState.groupInFilter && !this.state.groupInFilter)
    ) {
      this.getStatsByExpirationForPieChart(true)
      if (!companyId && !this.state.groupInFilter) {
        this.setState({
          contractsListLoading: !this.state.contractsListLoading,
        })
        this.props
          .loadExpiringContracts(6, Number(totalExpiringFilterWithinDays))
          .then((expiringContracts) => this.setState({ contractsListLoading: false, expiringContracts }))
      }
    }
    if (stateData !== oldState.stateData) {
      this.calcActive()
    }
  }

  render() {
    const today = new Date()
    today.setDate(new Date().getDate() + 90)
    const { t } = this.props
    const { tenants } = this.state
    const {
      filteredCustomers,
      prefilteredCustomers,
      searchString,
      loading,
      groupInFilter,
      orderFormTenantDict,
      totalExpiringFilterWithinDays,
    } = this.state

    return (
      <>
        <Loader blocking={loading} style={{ overflow: 'hidden' }}>
          <ul className="breadcrumbs">
            <li>
              <NavLink to={this.props.user?.isInternalUser ? '/dashboard' : '/'} exact={true}>
                <span>{t('DASHBOARD')}</span>
              </NavLink>
            </li>
            {this.props.match.params.companyId &&
              this.props.history.location.pathname.indexOf('treeview') <= -1 &&
              this.state.filteredCustomers?.map(
                (el) =>
                  !!el?.parents?.length &&
                  el?.parents?.length > 0 &&
                  el?.parents?.map((p) => (
                    <li>
                      <NavLink to={`/${this.props.user?.isInternalUser ? 'dashboard' : 'dashboard-home'}/${p.id}`}>
                        <span>{p.name}</span>
                      </NavLink>
                    </li>
                  ))
              )}

            {!!this.state.groupInFilter && (
              <li>
                <span>{tenants.filter((el) => el.id === this.state.groupInFilter)[0].name}</span>
              </li>
            )}
            <li>
              <span>{this.props.match?.params?.companyId && <span>{this.state.filteredCustomers[0]?.name}</span>}</span>
            </li>
            {this.props.match?.params?.companyId && (
              <li>
                <span></span>
              </li>
            )}
          </ul>
          <div className="row dashArea">
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 order-2 order-lg-1 order-sm-2 order-md-1">
              {((this.state.allCustomersAmount && this.state.allCustomersAmount > 1) ||
                this.state.orderFormsForActions.length > 0) &&
                !this.props.match.params.companyId && (
                  <div className="dashbox d-none d-md-block">
                    <div className="box-title" style={{ display: 'flex' }}>
                      <span>
                        <i className="icon-actions"></i>
                        {t('ACTIONS')}
                      </span>
                      {this.props.user?.isInternalUser && (
                        <div className="selectArea">
                          <select onChange={(e) => this.onGroupFilterChange(e)}>
                            <option value={''}>
                              {t('ALL')} {t('GROUPS')}
                            </option>
                            {tenants
                              .filter((te) => orderFormTenantDict[te.id])
                              .map((te, i) => (
                                <option key={i} selected={te.id === groupInFilter} value={te.id}>
                                  {te.name} {t('GROUP')}
                                </option>
                              ))}
                          </select>
                          <i className="icon-bottom" />
                        </div>
                      )}
                    </div>
                    <div className="box3 white" style={{ zIndex: 4 }}>
                      {this.props.user?.isInternalUser && this.state.orderFormsLoading ? (
                        <div
                          style={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'center',
                          }}
                        >
                          <LoadingSpinner />
                        </div>
                      ) : (
                        this.props.user?.canManageOrders &&
                        this.state.orderFormsForActions.length > 0 && (
                          <ul className="actionsList">
                            {this.state.orderFormsForActions.map((el) => {
                              const tooltip = Orders.getFormGenericTooltip(el, this.props.i18n.language)
                              return (
                                <li key={el.id}>
                                  <NavLink to={`/requests/new/${el.id}`} exact={true}>
                                    <div className="actionBox">
                                      <div className="action">
                                        {!!tooltip && (
                                          <div className="tooltipArea">
                                            <i className="icon-info" />
                                            <span className="generic-tooltip">{tooltip}</span>
                                          </div>
                                        )}
                                        <i className={el.icon}></i>
                                        <span className="actionName">
                                          {getFormTitle(el, this.props.i18n.language) || el.id}
                                        </span>
                                      </div>
                                    </div>
                                  </NavLink>
                                </li>
                              )
                            })}
                          </ul>
                        )
                      )}
                      {!this.props.match.params.companyId && (
                        <div className="viewAndFilterSection">
                          {this.props.user?.isAdmin && (
                            <div onClick={() => this.switchTreeViewMode()} className="treeViewButton">
                              <i className={this.state.treeViewMode ? 'icon-company-view' : 'icon-assign'} />
                            </div>
                          )}
                          <div className="searchBox">
                            <label>{t('CUSTOMER_SEARCH')}:</label>
                            <div className="input-area">
                              <input
                                autoFocus={true}
                                className="transparent"
                                type="text"
                                name={`fieldnameveryunique${new Date().getTime()}`}
                                autoComplete="none"
                                list="autocompleteOff"
                                onKeyDown={(e) => this.instantSearch(e)}
                                onChange={(e) => this.searchChanged(e)}
                                value={searchString}
                                placeholder={t('FIND_CUSTOMER_BY_KEYWORD')}
                              />
                              <button title="Clear" className="clr-btn" onClick={() => this.searchChanged()}>
                                <span className="icon-clear"></span>
                              </button>
                              <i className="icon-search"></i>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              {(this.props.user?.tags?.includes('allownotifications') || this.props.user?.isAdmin) && (
                <LastActivities />
              )}
              {!this.state.customersCalculating && (
                <Companies
                  companies={
                    this.props.history.location.pathname.indexOf('treeview') > -1
                      ? this.state.customersForDetailedTreeview
                      : filteredCustomers
                  }
                  tenants={this.state.tenants}
                  isInternalUser={this.props.user?.isInternalUser}
                  isAdmin={this.props.user?.isAdmin}
                  user={this.props.user}
                  isTreeViewMode={this.state.treeViewMode}
                  selectedCompany={this.props.match.params.companyId}
                  showStats
                />
              )}

              {prefilteredCustomers.length <= 4 && (
                <div className="row">
                  <DashboardCharts
                    chartsAnimation={this.state.chartsAnimation}
                    statusInFuelType={this.state.statusInFuelType}
                    onChangeFilter={this.filterChange}
                    onFuelTypeFilterChange={this.fuelTypeFilterChange}
                    selectedTenant={this.state.groupInFilter}
                    companyId={this.props.match.params.companyId}
                    expirationLoading={this.state.expirationLoading}
                    filterWithinDays={this.state.filterWithinDays}
                    refreshVehicleChart={this.state.refreshVehicleChart}
                    refreshExpirationChart={this.state.refreshExpirationChart}
                    showChart={this.state.showChart}
                    showAdditionalCharts={this.state.showAdditionalCharts}
                    expirationYears={this.state.expirationYears}
                    stateData={this.state.stateData}
                    expirationData={this.state.expirationData}
                    productData={this.state.productData}
                    fuelData={this.state.fuelData}
                    vehicleData={this.state.vehicleData}
                  />
                </div>
              )}
            </div>
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 order-1 order-lg-2 order-sm-1 order-md-2">
              <div className="row">
                {((this.state.allCustomersAmount && this.state.allCustomersAmount > 1) ||
                  this.state.orderFormsForActions.length > 0) &&
                  !this.props.match.params.companyId && (
                    <div className="dashbox col-12 col-sm-12 col-lg-12 col-md-12 d-md-none d-block">
                      <div className="box-title">
                        <span>
                          <i className="icon-actions"></i>
                          {t('ACTIONS')}
                        </span>
                        {this.props.user?.isInternalUser && (
                          <div className="selectArea">
                            <select onChange={(e) => this.onGroupFilterChange(e)}>
                              <option value={''}>
                                {t('ALL')} {t('GROUPS')}
                              </option>
                              {tenants
                                .filter((te) => orderFormTenantDict[te.id])
                                .map((te, i) => (
                                  <option key={i} selected={te.id === groupInFilter} value={te.id}>
                                    {te.name} {t('GROUP')}
                                  </option>
                                ))}
                            </select>
                            <i className="icon-bottom" />
                          </div>
                        )}
                      </div>
                      <div className="box3 white">
                        {this.props.user?.isInternalUser && this.state.orderFormsLoading ? (
                          <div
                            style={{
                              display: 'flex',
                              width: '100%',
                              justifyContent: 'center',
                            }}
                          >
                            <LoadingSpinner />
                          </div>
                        ) : (
                          this.props.user?.canManageOrders &&
                          this.state.orderFormsForActions.length > 0 && (
                            <ul className="actionsList">
                              {this.state.orderFormsForActions.map((el) => {
                                const tooltip = Orders.getFormGenericTooltip(el, this.props.i18n.language)
                                return (
                                  <li>
                                    <NavLink to={`/requests/new/${el.id}`} exact={true}>
                                      <div className="actionBox">
                                        <div className="action">
                                          {!!tooltip && (
                                            <div className="tooltipArea">
                                              <i className="icon-info" />
                                              <span className="generic-tooltip">{tooltip}</span>
                                            </div>
                                          )}
                                          <i className={el.icon}></i>
                                          <span className="actionName">
                                            {getFormTitle(el, this.props.i18n.language) || el.id}
                                          </span>
                                        </div>
                                      </div>
                                    </NavLink>
                                  </li>
                                )
                              })}
                            </ul>
                          )
                        )}
                        {!this.props.match.params.companyId && (
                          <div className="viewAndFilterSection">
                            {this.props.user?.isAdmin && (
                              <div onClick={() => this.switchTreeViewMode()} className="treeViewButton">
                                <i className={this.state.treeViewMode ? 'icon-company-view' : 'icon-assign'} />
                              </div>
                            )}
                            <div className="searchBox">
                              <label>{t('CUSTOMER_SEARCH')}:</label>
                              <div className="input-area">
                                <input
                                  autoFocus={true}
                                  className="transparent"
                                  type="text"
                                  name={`fieldnameveryunique${new Date().getTime()}`}
                                  autoComplete="none"
                                  list="autocompleteOff"
                                  onKeyDown={(e) => this.instantSearch(e)}
                                  onChange={(e) => this.searchChanged(e)}
                                  value={searchString}
                                  placeholder={t('FIND_CUSTOMER_BY_KEYWORD')}
                                />
                                <button title="Clear" className="clr-btn" onClick={() => this.searchChanged()}>
                                  <span className="icon-clear"></span>
                                </button>
                                <i className="icon-search"></i>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                <ContractStatus
                  companyId={this.props.match.params.companyId}
                  handleActiveRedirect={() => this.expiringContractsOnGeneralContracts(true)}
                  handleInitializedRedirect={() => this.expiringContractsOnGeneralContracts(false, true)}
                  handleExpiringRedirect={() => this.expiringContractsOnGeneralContracts(false, false, true)}
                  handleExpirationDateChange={(e) => this.filterTotalExpiringContracts(e)}
                  treeViewMode={this.state.treeViewMode}
                  contractsListLoading={this.state.contractsListLoading}
                  activeNaturesStats={this.state.activeNaturesStats}
                  initializedNaturesStats={this.state.initializedNaturesStats}
                  expiringNaturesStats={this.state.expiringNaturesStats}
                  totalExpiringFilterWithinDays={totalExpiringFilterWithinDays}
                  contractsToShow={this.state.contractsToShow}
                  rootCompany={
                    this.props.history.location.pathname.indexOf('treeview') > -1
                      ? this.state.customersForDetailedTreeview[0]
                      : undefined
                  }
                  companies={
                    this.props.history.location.pathname.indexOf('treeview') > -1 ? undefined : filteredCustomers
                  }
                />

                {prefilteredCustomers.length > 4 && (
                  <DashboardCharts
                    chartsAnimation={this.state.chartsAnimation}
                    statusInFuelType={this.state.statusInFuelType}
                    onChangeFilter={this.filterChange}
                    onFuelTypeFilterChange={this.fuelTypeFilterChange}
                    companyId={this.props.match?.params?.companyId}
                    expirationLoading={this.state.expirationLoading}
                    filterWithinDays={this.state.filterWithinDays}
                    refreshVehicleChart={this.state.refreshVehicleChart}
                    refreshExpirationChart={this.state.refreshExpirationChart}
                    showChart={this.state.showChart}
                    showAdditionalCharts={this.state.showAdditionalCharts}
                    expirationYears={this.state.expirationYears}
                    stateData={this.state.stateData}
                    productData={this.state.productData}
                    fuelData={this.state.fuelData}
                    expirationData={this.state.expirationData}
                    vehicleData={this.state.vehicleData}
                    isTreeView={this.state.treeViewMode}
                  />
                )}
              </div>
            </div>
          </div>
        </Loader>
      </>
    )
  }

  private renderCompaniesTreeviewMode() {
    const customersToTreeview: ICustomerViewModel[] = JSON.parse(JSON.stringify(this.state.filteredCustomers))

    const TreeviewCustomers = customersToTreeview.filter((el) => el.children?.length && el.children.length > 0)

    this.setState({
      filteredCustomers: TreeviewCustomers.sort((a, b) => a.name.localeCompare(b.name)),
      customersCalculating: false,
    })
  }

  private switchTreeViewMode() {
    this.setState({
      treeViewMode: !this.state.treeViewMode,
    })
  }

  private onGroupFilterChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const groupInFilter = e.target.value
    this.setState({
      groupInFilter,
    })
  }

  private filterRequestFormIfRestricted(currentForm: OrdersFormViewModel): boolean {
    const { user, customers } = this.props

    if (currentForm.filterCompamniesByMatchingApprovalFlows && !user?.isInternalUser) {
      const validCompaniesForApprovalFlows: { [id: string]: boolean } = {}

      currentForm?.approvalProcessConfigs
        ?.filter((c) => c.validCompanies.length > 0)
        .forEach((c) => {
          c.validCompanies.forEach((vc) => {
            validCompaniesForApprovalFlows[vc] = true
          })
        })

      return (
        !!currentForm.ownerTenant &&
        currentForm.ownerTenant !== emptyGuid &&
        customers.filter((c) => c.tenantId === currentForm.ownerTenant && validCompaniesForApprovalFlows[c.id]).length >
          0
      )
    }
    return true
  }

  private prepareFormsToRender() {
    const { user, i18n } = this.props
    const { tenants } = this.state
    const { groupInFilter, orderForms } = this.state
    const tenantIds = tenants?.map((t) => t.id) || []
    const orderFormsFiltered =
      user?.isInternalUser && !!groupInFilter ? orderForms.filter((f) => f.ownerTenant === groupInFilter) : orderForms

    const { language } = i18n
    const orderFormsForActions = (
      tenantIds.length > 0 ? orderFormsFiltered.filter((f) => tenantIds.includes(f.ownerTenant)) : orderFormsFiltered
    )
      .filter((f) => this.filterRequestFormIfRestricted(f))
      .sort((a, b) => getFormTitle(a, language).localeCompare(getFormTitle(b, language)))

    this.setState({
      orderFormsForActions,
    })
  }

  private natureCalc() {
    let dataActive: { [key: string]: number } = {}
    let dataInitialized: { [key: string]: number } = {}
    let dataExpiring: { [key: string]: number } = {}
    const companyId = this.props.match?.params?.companyId
    if (this.props.history.location.pathname.indexOf('treeview') > -1) {
      Object.keys(this.state.activeNatures).forEach((el) => {
        if (this.state.activePaths.includes(el)) {
          Object.keys(this.state.activeNatures[el]).forEach((q) => {
            if (Object.keys(dataActive).filter((k) => k === q).length === 0) {
              dataActive = { ...dataActive, [q]: this.state.activeNatures[el][q] }
            } else {
              dataActive[q] = dataActive[q] + this.state.activeNatures[el][q]
            }
          })
        }
      })
      Object.keys(this.state.initializedNatures).forEach((el) => {
        if (this.state.initializedPaths.includes(el)) {
          Object.keys(this.state.initializedNatures[el]).forEach((q) => {
            if (Object.keys(dataInitialized).filter((k) => k === q).length === 0) {
              dataInitialized = { ...dataInitialized, [q]: this.state.initializedNatures[el][q] }
            } else {
              dataInitialized[q] = dataInitialized[q] + this.state.initializedNatures[el][q]
            }
          })
        }
      })
      Object.keys(this.state.expiringNatures).forEach((el) => {
        if (this.state.activePaths.includes(el)) {
          Object.keys(this.state.expiringNatures[el]).forEach((q) => {
            if (Object.keys(dataExpiring).filter((k) => k === q).length === 0) {
              dataExpiring = { ...dataExpiring, [q]: this.state.expiringNatures[el][q] }
            } else {
              dataExpiring[q] = dataExpiring[q] + this.state.expiringNatures[el][q]
            }
          })
        }
      })
    } else {
      Object.keys(this.state.activeNatures).forEach((el) => {
        if (companyId ? el.toLowerCase().indexOf(companyId) > -1 : !!el) {
          Object.keys(this.state.activeNatures[el]).forEach((q) => {
            if (Object.keys(dataActive).filter((k) => k === q).length === 0) {
              dataActive = { ...dataActive, [q]: this.state.activeNatures[el][q] }
            } else {
              dataActive[q] = dataActive[q] + this.state.activeNatures[el][q]
            }
          })
        }
      })
      Object.keys(this.state.initializedNatures).forEach((el) => {
        if (companyId ? el.toLowerCase().indexOf(companyId.toLowerCase()) > -1 : !!el) {
          Object.keys(this.state.initializedNatures[el]).forEach((q) => {
            if (Object.keys(dataInitialized).filter((k) => k === q).length === 0) {
              dataInitialized = { ...dataInitialized, [q]: this.state.initializedNatures[el][q] }
            } else {
              dataInitialized[q] = dataInitialized[q] + this.state.initializedNatures[el][q]
            }
          })
        }
      })
      Object.keys(this.state.expiringNatures).forEach((el) => {
        if (companyId ? el.toLowerCase().indexOf(companyId.toLowerCase()) > -1 : !!el) {
          Object.keys(this.state.expiringNatures[el]).forEach((q) => {
            if (Object.keys(dataExpiring).filter((k) => k === q).length === 0) {
              dataExpiring = { ...dataExpiring, [q]: this.state.expiringNatures[el][q] }
            } else {
              dataExpiring[q] = dataExpiring[q] + this.state.expiringNatures[el][q]
            }
          })
        }
      })
    }
    this.setState({
      activeNaturesStats: dataActive,
      initializedNaturesStats: dataInitialized,
      expiringNaturesStats: dataExpiring,
    })
  }

  private fuelTypeFilterChange(status: string) {
    const { t } = this.props
    const statuses: ContractState[] =
      status === 'ACTIVE'
        ? [ContractState.Running, ContractState.Extended]
        : status === t('INITIALIZED')
        ? [ContractState.Initialized]
        : status === t('TERMINATED')
        ? [ContractState.Terminated]
        : [ContractState.Canceled]
    this.props.getCustomersStatistics(ContractsGrouping.ByVehicleFuelType, statuses).then((statsByVehicleFuelType) => {
      this.setState({ statsByVehicleFuelType })
      this.getStatsByFuelTypeForPieChart()
    })
  }

  private filterChange(days: string) {
    this.setState({
      filterWithinDays: days,
    })
  }

  private renderCompanies() {
    const treeviewInPath = this.props.history.location.pathname.indexOf('treeview') > -1
    if (Arr.any(this.state.rawPrefilteredCustomers) && !treeviewInPath && !this.props.match.params.companyId) {
      this.setState({
        customersCalculating: true,
      })
      if (this.props.match.params.companyId) {
        const filtered = this.state.rawPrefilteredCustomers.filter((el) => {
          if (el.id === this.props.match.params.companyId) {
            return el
          }
        })
        this.setState({
          filteredCustomers: filtered,
          customersCalculating: false,
        })
        return
      } else {
        this.setState({
          filteredCustomers: this.state.rawPrefilteredCustomers.filter((c) => {
            return this.reduceValidContractCount(
              this.props.user?.isInternalUser
                ? allowedContractStatusesForAdmin.map((s) => c.contracts[s]).filter((n) => n > 0)
                : allowedContractStatusesForUser.map((s) => c.contracts[s]).filter((n) => n > 0)
            )
          }),
          customersCalculating: false,
        })
      }
    }

    this.setState({
      prefilteredCustomers: [],
      filteredCustomers: [],
      customersCalculating: true,
    })
    const customersFromProps: ICustomerViewModel[] = JSON.parse(JSON.stringify(this.props.customers))
    const prefilteredCustomers = customersFromProps.filter((c) => {
      return this.reduceValidContractCount(
        this.props.user?.isInternalUser
          ? allowedContractStatusesForAdmin.map((s) => c.contracts[s]).filter((n) => n > 0)
          : allowedContractStatusesForUser.map((s) => c.contracts[s]).filter((n) => n > 0)
      )
    })

    if (this.props.match.params.companyId) {
      const companyId = this.props.match.params.companyId

      const isAlreadyInPrefiltered = prefilteredCustomers.some((c) => c.id === companyId)

      if (!isAlreadyInPrefiltered) {
        const customer = customersFromProps.find((c) => c.id === companyId)

        if (customer) {
          prefilteredCustomers.push(customer)
        }
      }
    }

    const prefilteredCustomersForTreeview = customersFromProps.filter((c) => {
      if (this.props.match?.params?.companyId) {
        if (c.id === this.props.match?.params?.companyId) {
          return (
            this.reduceValidContractCount(
              this.props.user?.isAdmin
                ? allowedContractStatusesForAdmin.map((s) => c.contracts[s]).filter((n) => n > 0)
                : allowedContractStatusesForUser.map((s) => c.contracts[s]).filter((n) => n > 0)
            ) || c
          )
        }
      }
    })

    if (this.state.allCustomersAmount === undefined && !this.props.match.params.companyId) {
      this.setState({
        allCustomersAmount: prefilteredCustomers.length,
      })
    }

    if (!treeviewInPath) {
      const childrenExpiration = []
      const source = treeviewInPath ? prefilteredCustomersForTreeview : prefilteredCustomers
      source.forEach(
        (el) => (
          (el.children = []),
          customersFromProps.forEach((cu) =>
            cu?.parentId?.toLowerCase().includes(el.id.toLowerCase())
              ? (el.children.push(cu),
                Object.keys(this.state.statsByExpiration).filter((e) => {
                  if (e.toLowerCase().indexOf(cu?.id.toLowerCase()) > -1) {
                    childrenExpiration.push(this.state.statsByExpiration[e.toUpperCase()])
                  }
                }))
              : null
          )
        )
      )
    }

    if (treeviewInPath) {
      const customersMap = new Map<string, ICustomerViewModel>()
      customersFromProps.forEach((c) => {
        customersMap.set(c.id, { ...c, children: [] })
      })

      customersFromProps.forEach((c) => {
        if (c.parentId) {
          const parent = customersMap.get(c.parentId)
          if (parent) {
            const child = customersMap.get(c.id)
            if (child) {
              parent.children?.push(child)
            }
          }
        }
      })

      const targetCompanyId = this.props.match?.params?.companyId
      if (!targetCompanyId) {
        throw new Error('Company ID is required')
      }

      const selectedCompany = customersMap.get(targetCompanyId)
      if (!selectedCompany) {
        throw new Error('Selected company not found')
      }

      let rootParent = selectedCompany
      while (rootParent?.parentId) {
        const parent = customersMap.get(rootParent.parentId)
        if (parent) {
          rootParent = parent
        }
      }
      const treeForRenderArray = [rootParent]

      this.setState({
        treeViewMode: true,
        customersForDetailedTreeview: treeForRenderArray,
      })
    }

    if (this.state.groupInFilter) {
      const groupedCustomers: ICustomerViewModel[] = []
      prefilteredCustomers.map((el) => {
        if (el.tenantId?.toLowerCase() === this.state.groupInFilter?.toLowerCase()) {
          groupedCustomers.push(el)
        }
      })
      this.setState({
        prefilteredCustomers: groupedCustomers,
        filteredCustomers: groupedCustomers,
        customersCalculating: false,
      })
      return
    }

    const filtered = this.props.match.params.companyId
      ? prefilteredCustomers.filter((el) => {
          if (el.id === this.props.match.params.companyId) {
            return el
          }
        })
      : prefilteredCustomers

    this.setState({
      rawPrefilteredCustomers: !Arr.any(this.state.rawPrefilteredCustomers)
        ? prefilteredCustomers
        : this.state.rawPrefilteredCustomers,
      prefilteredCustomers: prefilteredCustomers,
      filteredCustomers: treeviewInPath ? prefilteredCustomersForTreeview : filtered,
      customersCalculating: false,
    })
  }

  private instantSearch(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      this.searchChanged(e, true)
    }
  }

  private searchChanged(
    e?: React.ChangeEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>,
    instant?: boolean
  ) {
    const eventTarget = e?.target
    const value = eventTarget && 'value' in eventTarget ? eventTarget.value : ''
    FrontendSettings.set(FrontendSettingsKeys.dashboardSearchString, value)
    this.setState({
      searchString: value,
    })
    const newDebounce = { ...this.state.debounce }
    if (newDebounce.timeout) {
      clearTimeout(newDebounce.timeout)
      newDebounce.timeout = undefined
    }

    const mainTimeoutFunc = () => {
      this.setState({
        loading: true,
      })
      setTimeout(() => {
        this.setState({
          loading: false,
        })
      }, 500)
      this.setState({
        debounce: {
          ...this.state.debounce,
          change: new Date().getTime(),
        },
      })
    }

    if (value && value.length > 0 && !instant) {
      newDebounce.timeout = window.setTimeout(mainTimeoutFunc, 2000)
      this.setState({
        debounce: newDebounce,
      })
    } else {
      this.setState({
        debounce: newDebounce,
      })
      mainTimeoutFunc()
    }
  }

  private reduceValidContractCount(contracts: number[]): boolean {
    return contracts.length > 0
      ? contracts.reduce((ac, curr) => ac + curr) > 0
      : this.props.user?.isInternalUser
      ? false
      : true
  }

  private filterTotalExpiringContracts(e: React.ChangeEvent<HTMLSelectElement>) {
    this.props
      .getCustomersStatistics(
        ContractsGrouping.ByVehicleNature,
        [ContractState.Running, ContractState.Extended],
        Number(e.target.value)
      )
      .then((res3) => {
        this.setState({ expiringNatures: res3 })
      })
    this.setState({
      totalExpiringFilterWithinDays: e.target.value,
    })
    FrontendSettings.set(FrontendSettingsKeys.expiringDaysFilter, e.target.value)
  }

  private expiringContractsOnGeneralContracts(active?: boolean, pending?: boolean, expiring?: boolean) {
    function companiesCollector(inputArray: ICustomerViewModel[]) {
      const outputArr: string[] = []
      collectCompanies(0, inputArray, outputArr)
      return outputArr
    }
    function collectCompanies(i: number, arr: ICustomerViewModel[], outputArr: string[]) {
      if (i >= arr.length) {
        return
      }

      outputArr.push(arr[i].id)

      if (Arr.any(arr[i].children)) {
        collectCompanies(0, arr[i].children, outputArr)
      }
      collectCompanies(i + 1, arr, outputArr)
    }

    if (this.props.history.location.pathname.indexOf('treeview') > -1) {
      const companiesToShow = companiesCollector(this.state.customersForDetailedTreeview)
      FrontendSettings.setObject(FrontendSettingsKeys.expiringCompaniesTreeview, companiesToShow)
    }
    if (active) {
      FrontendSettings.setObject(FrontendSettingsKeys.contractStateFilterState, [
        ContractState.Running,
        ContractState.Extended,
      ])
      this.props.history.push(`/generalContracts/${this.props.match.params.companyId}`)
      return
    }

    if (pending) {
      this.props.history.push(`/orderAndDelivery/${this.props.match.params.companyId}`)
      return
    }

    if (expiring) {
      FrontendSettings.setObject(FrontendSettingsKeys.contractStateFilterState, ['Expiring'])
      this.props.updateFilterValue({ newFilters: { state: ['Expiring'] }, gridId: 'GeneralContracts' })
      const pathToGeneralContracts = this.props.match.params.companyId
        ? `/generalContracts/${this.props.match.params.companyId}/expiringContracts/${this.state.totalExpiringFilterWithinDays}`
        : `/generalContracts/allCustomers/expiringContracts/${this.state.totalExpiringFilterWithinDays}`
      this.props.history.push(pathToGeneralContracts)
    }
  }

  private calcActive() {
    let calcActive: number = 0
    this.state.stateData?.data?.labels?.forEach((obj, i) => {
      if (obj === this.props.t('RUNNING') || obj === this.props.t('EXTENDED')) {
        calcActive = calcActive + this.state.stateData?.data?.datasets[0]?.data[i]
      }
    })
    this.setState({
      activeContractsAmount: calcActive,
    })
  }

  private getStatsByStateForPieChart() {
    const statsInArray = []
    const statsHolder = {}
    const activePaths = []
    const initializedPaths = []
    const { stats } = this.props
    const statusForRunning = [ContractState.Running]
    const statusForExtended = [ContractState.Extended]
    const statusForTerminated = [ContractState.Terminated]
    const statusForClosed = [ContractState.Closed]
    const statusForInitialized = [ContractState.Initialized]
    Object.keys(stats).map((obj) => {
      let closedAmount = 0
      statusForClosed.forEach((status) => {
        if (this.props.match?.params?.companyId?.length) {
          if (this.props.history.location.pathname.indexOf('treeview') > -1) {
            this.state.filteredCustomers.map((el) => {
              if (obj.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                if (stats[obj][status]) {
                  closedAmount += stats[obj][status] || 0
                }
              }
            })
            if (Arr.any(this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children)) {
              this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children.forEach((ch) => {
                if (obj.toLowerCase().indexOf(ch.id.toLowerCase()) > -1) {
                  closedAmount += stats[obj][status] || 0
                }
              })
            }
            statsInArray.push({ name: status, val: closedAmount })
          } else {
            if (obj.toLowerCase().indexOf(this.props.match.params.companyId.toLowerCase()) > -1) {
              if (stats[obj][status]) {
                statsInArray.push({ name: status, val: stats[obj][status] } || 0)
              }
            }
          }
        } else {
          if (this.state.groupInFilter) {
            this.state.filteredCustomers.map((el) => {
              if (el.tenantId === this.state.groupInFilter) {
                if (obj.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                  if (stats[obj][status]) {
                    statsInArray.push({ name: status, val: stats[obj][status] } || 0)
                  }
                }
              }
            })
          } else {
            if (stats[obj][status]) {
              statsInArray.push({ name: status, val: stats[obj][status] } || 0)
            }
          }
        }
      })
      let terminatedAmount = 0
      statusForTerminated.forEach((status) => {
        if (this.props.match?.params?.companyId?.length) {
          if (this.props.history.location.pathname.indexOf('treeview') > -1) {
            this.state.filteredCustomers.map((el) => {
              if (obj.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                if (stats[obj][status]) {
                  terminatedAmount += stats[obj][status] || 0
                }
              }
            })
            if (Arr.any(this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children)) {
              this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children.forEach((ch) => {
                if (obj.toLowerCase().indexOf(ch.id.toLowerCase()) > -1) {
                  terminatedAmount += stats[obj][status] || 0
                }
              })
            }
            statsInArray.push({ name: status, val: terminatedAmount })
          } else {
            if (obj.toLowerCase().indexOf(this.props.match.params.companyId.toLowerCase()) > -1) {
              if (stats[obj][status]) {
                statsInArray.push({ name: status, val: stats[obj][status] } || 0)
              }
            }
          }
        } else {
          if (this.state.groupInFilter) {
            this.state.filteredCustomers.map((el) => {
              if (el.tenantId === this.state.groupInFilter) {
                if (obj.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                  if (stats[obj][status]) {
                    statsInArray.push({ name: status, val: stats[obj][status] } || 0)
                  }
                }
              }
            })
          } else {
            if (stats[obj][status]) {
              statsInArray.push({ name: status, val: stats[obj][status] } || 0)
            }
          }
        }
      })
      let runningAmount = 0
      statusForRunning.forEach((status) => {
        if (this.props.match?.params?.companyId?.length) {
          if (this.props.history.location.pathname.indexOf('treeview') > -1) {
            this.state.filteredCustomers.map((el) => {
              if (obj.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                if (stats[obj][status]) {
                  runningAmount += stats[obj][status] || 0
                  activePaths.push(obj)
                }
              }
            })
            if (Arr.any(this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children)) {
              this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children.forEach((ch) => {
                if (obj.toLowerCase().indexOf(ch.id.toLowerCase()) > -1) {
                  runningAmount += stats[obj][status] || 0
                  activePaths.push(obj)
                }
              })
            }
            statsInArray.push({ name: status, val: runningAmount })
          } else {
            if (obj.toLowerCase().indexOf(this.props.match.params.companyId.toLowerCase()) > -1) {
              if (stats[obj][status]) {
                statsInArray.push({ name: status, val: stats[obj][status] } || 0)
              }
            }
          }
        } else {
          if (this.state.groupInFilter) {
            this.state.filteredCustomers.map((el) => {
              if (el.tenantId === this.state.groupInFilter) {
                if (obj.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                  if (stats[obj][status]) {
                    statsInArray.push({ name: status, val: stats[obj][status] } || 0)
                  }
                }
              }
            })
          } else {
            if (stats[obj][status]) {
              statsInArray.push({ name: status, val: stats[obj][status] } || 0)
            }
          }
        }
      })

      let extendedAmount = 0
      statusForExtended.forEach((status) => {
        if (this.props.match?.params?.companyId?.length) {
          if (this.props.history.location.pathname.indexOf('treeview') > -1) {
            this.state.filteredCustomers.map((el) => {
              if (obj.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                if (stats[obj][status]) {
                  extendedAmount += stats[obj][status] || 0
                }
              }
            })
            if (Arr.any(this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children)) {
              this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children.forEach((ch) => {
                if (obj.toLowerCase().indexOf(ch.id.toLowerCase()) > -1) {
                  extendedAmount += stats[obj][status] || 0
                }
              })
            }
            statsInArray.push({ name: status, val: extendedAmount })
          } else {
            if (obj.toLowerCase().indexOf(this.props.match.params.companyId.toLowerCase()) > -1) {
              if (stats[obj][status]) {
                statsInArray.push({ name: status, val: stats[obj][status] } || 0)
              }
            }
          }
        } else {
          if (this.state.groupInFilter) {
            this.state.filteredCustomers.map((el) => {
              if (el.tenantId === this.state.groupInFilter) {
                if (obj.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                  if (stats[obj][status]) {
                    statsInArray.push({ name: status, val: stats[obj][status] } || 0)
                  }
                }
              }
            })
          } else {
            if (stats[obj][status]) {
              statsInArray.push({ name: status, val: stats[obj][status] } || 0)
            }
          }
        }
      })
      let initializedAmount = 0
      statusForInitialized.forEach((status) => {
        if (this.props.match?.params?.companyId?.length) {
          if (this.props.history.location.pathname.indexOf('treeview') > -1) {
            this.state.filteredCustomers.map((el) => {
              if (obj.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                if (stats[obj][status]) {
                  initializedAmount += stats[obj][status] || 0
                  initializedPaths.push(obj)
                }
              }
            })
            if (Arr.any(this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children)) {
              this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children.forEach((ch) => {
                if (obj.toLowerCase().indexOf(ch.id.toLowerCase()) > -1) {
                  initializedAmount += stats[obj][status] || 0
                  initializedPaths.push(obj)
                }
              })
            }
            statsInArray.push({ name: status, val: initializedAmount })
          } else {
            if (obj.toLowerCase().indexOf(this.props.match.params.companyId.toLowerCase()) > -1) {
              if (stats[obj][status]) {
                statsInArray.push({ name: status, val: stats[obj][status] } || 0)
              }
            }
          }
        } else {
          if (this.state.groupInFilter) {
            this.state.filteredCustomers.map((el) => {
              if (el.tenantId === this.state.groupInFilter) {
                if (obj.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                  if (stats[obj][status]) {
                    statsInArray.push({ name: status, val: stats[obj][status] } || 0)
                  }
                }
              }
            })
          } else {
            if (stats[obj][status]) {
              statsInArray.push({ name: status, val: stats[obj][status] } || 0)
            }
          }
        }
      })
    })
    statsInArray.forEach((d) => {
      if (d.name in statsHolder) {
        statsHolder[d.name] = statsHolder[d.name] + d.val
      } else {
        statsHolder[d.name] = d.val
      }
    })
    const rawData = []
    const options = {
      maintainAspectRatio: false,
      responsive: true,
      borderWidth: 0,
      plugins: {
        datalabels: {
          color: 'white',
        },
      },
    }
    // tslint:disable-next-line: forin
    for (const el in statsHolder) {
      rawData.push({
        label: this.props.t(el.toUpperCase()),
        data: statsHolder[el],
        background:
          el === 'Terminated'
            ? '#FF5555'
            : el === 'Running'
            ? '#39B54A'
            : el === 'Extended'
            ? '#5fcc6d'
            : el === 'Initialized'
            ? '#2BAAE2'
            : el === 'Closed'
            ? '#FF0000'
            : '',
      })
    }
    if (Arr.any(rawData)) {
      const labelsSorted = []
      const dataSorted = []
      const backgroundsSorted = []
      rawData
        .sort((a, b) => a.label.localeCompare(b.label))
        .forEach((el) => (labelsSorted.push(el.label), dataSorted.push(el.data), backgroundsSorted.push(el.background)))
      this.setState({
        stateData: {
          options: options,
          data: {
            labels: labelsSorted,
            datasets: [{ label: '', data: dataSorted, backgroundColor: backgroundsSorted }],
          },
        },
      })
    }

    this.setState({
      activePaths,
      initializedPaths,
    })
    this.calcActive()
  }

  private getStatsByProductForPieChart() {
    const test = []
    const arr = []
    const newStats = {}
    const { statsByProduct } = this.state
    Object.keys(statsByProduct).map((e) => {
      if (this.props.match?.params?.companyId?.length) {
        if (this.props.history.location.pathname.indexOf('treeview') > -1) {
          this.state.filteredCustomers.map((el) => {
            if (e.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
              arr.push(statsByProduct[e])
            }
          })
          if (Arr.any(this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children)) {
            this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children.forEach((ch) => {
              if (e.toLowerCase().indexOf(ch.id.toLowerCase()) > -1) {
                arr.push(statsByProduct[e])
              }
            })
          }
        } else {
          if (e.toLowerCase().indexOf(this.props.match?.params?.companyId?.toLowerCase()) > -1) {
            arr.push(statsByProduct[e])
          }
        }
      } else {
        if (this.state.groupInFilter) {
          this.state.filteredCustomers.map((el) => {
            if (el.tenantId === this.state.groupInFilter) {
              if (e.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                arr.push(statsByProduct[e])
              }
            }
          })
        } else {
          arr.push(statsByProduct[e])
        }
      }
    })
    arr.map((obj) => {
      Object.keys(obj).map((el) =>
        test.push({
          name: productTypeIdDict[el],
          val: obj[el],
        })
      )
    })
    test.map((el) => {
      if (el.name in newStats) {
        newStats[el.name] = newStats[el.name] + el.val
      } else {
        newStats[el.name] = el.val
      }
    })
    const rawData = []
    const options = {
      maintainAspectRatio: false,
      responsive: true,
      scales: {
        x: {
          grid: {
            lineWidth: 0,
          },
        },
      },
      plugins: {
        datalabels: {
          color: 'white',
        },
        legend: {
          display: false,
        },
      },
    }
    for (const el in newStats) {
      rawData.push({
        label: el,
        data: newStats[el],
      })
    }
    const labelsSorted = []
    const dataSorted = []
    rawData
      .sort((a, b) => a.label.localeCompare(b.label))
      .forEach(
        (el) => (labelsSorted.push(this.props.t(`PRODUCT_SHORT_${el.label.toUpperCase()}`)), dataSorted.push(el.data))
      )
    if (Arr.any(rawData)) {
      this.setState({
        productData: {
          options: options,
          data: {
            labels: labelsSorted,
            datasets: [
              {
                label: '',
                data: dataSorted,
                backgroundColor: [
                  '#c3d583',
                  '#a2cd7e',
                  '#99D98C',
                  '#76C893',
                  '#52B69A',
                  '#34A0A4',
                  '#168AAD',
                  '#1A759F',
                  '#1E6091',
                  '#184E77',
                ],
              },
            ],
          },
        },
      })
    }
  }

  private getStatsByFuelTypeForPieChart() {
    const test = []
    const arr = []
    const newStats = {}
    const { statsByVehicleFuelType } = this.state
    Object.keys(statsByVehicleFuelType).map((e) => {
      if (this.props.match?.params?.companyId?.length) {
        if (this.props.history.location.pathname.indexOf('treeview') > -1) {
          this.state.filteredCustomers.map((el) => {
            if (e.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
              arr.push(statsByVehicleFuelType[e])
            }
          })
          if (Arr.any(this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children)) {
            this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children.forEach((ch) => {
              if (e.toLowerCase().indexOf(ch.id.toLowerCase()) > -1) {
                arr.push(statsByVehicleFuelType[e])
              }
            })
          }
        } else {
          if (e.toLowerCase().indexOf(this.props.match?.params?.companyId?.toLowerCase()) > -1) {
            arr.push(statsByVehicleFuelType[e])
          }
        }
      } else {
        if (this.state.groupInFilter) {
          this.state.filteredCustomers.map((el) => {
            if (el.tenantId === this.state.groupInFilter) {
              if (e.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                arr.push(statsByVehicleFuelType[e])
              }
            }
          })
        } else {
          arr.push(statsByVehicleFuelType[e])
        }
      }
    })
    arr.map((obj) => {
      Object.keys(obj).map((el) =>
        test.push({
          name: el,
          val: obj[el],
        })
      )
    })
    test.map((el) => {
      if (el.name in newStats) {
        newStats[el.name] = newStats[el.name] + el.val
      } else {
        newStats[el.name] = el.val
      }
    })
    const rawData = []
    const options = {
      maintainAspectRatio: false,
      borderWidth: 0,
      responsive: true,
      plugins: {
        datalabels: {
          color: 'white',
        },
      },
    }
    // tslint:disable-next-line: forin
    for (const el in newStats) {
      rawData.push({
        label: el === 'Undefined' ? this.props.t('NOT_SPECIFIED') : this.props.t(el.toUpperCase()),
        data: newStats[el],
        background:
          el === 'Diesel'
            ? '#000000'
            : el === 'HybridDiesel'
            ? '#808080'
            : el === 'HybridPetrol'
            ? '#5fcc6d'
            : el === 'Petrol'
            ? '#39B54A'
            : el === 'Electric'
            ? '#3CC8EB'
            : el === 'Gas'
            ? '#259CB9'
            : el === '0'
            ? '#FF0000'
            : el === 'Undefined'
            ? '#C4CA5C'
            : el === 'Ethanol'
            ? '#A96BB0'
            : el === 'E85'
            ? '#648c70'
            : '#75754a',
      })
    }
    if (Arr.any(rawData)) {
      const labelsSorted = []
      const dataSorted = []
      const backgroundsSorted = []
      rawData
        .sort((a, b) => a.label.localeCompare(b.label))
        .forEach((el) => (labelsSorted.push(el.label), dataSorted.push(el.data), backgroundsSorted.push(el.background)))
      this.setState({
        fuelData: {
          options: options,
          data: {
            labels: labelsSorted,
            datasets: [{ label: '', data: dataSorted, backgroundColor: backgroundsSorted }],
          },
        },
      })
    }
  }

  private getStatsByExpirationForPieChart(downloadUnits: boolean) {
    this.setState({
      refreshExpirationChart: true,
    })
    const allContracts = []
    const rawStats = []
    const arr = []
    const rawUnitsToRequest: string[] = []
    const newStats = {}
    const expirationYears = []
    let today = new Date()
    const { totalExpiringFilterWithinDays } = this.state
    const { statsByExpiration } = this.state
    const companyId = this.props.match?.params.companyId

    Object.keys(statsByExpiration).map((e) => {
      if (this.props.match?.params?.companyId?.length) {
        if (this.props.history.location.pathname.indexOf('treeview') > -1) {
          this.state.filteredCustomers.map((el) => {
            if (e.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
              Object.keys(statsByExpiration[e]).map((obj) => {
                if (Number(obj) <= Number(totalExpiringFilterWithinDays) && Number(obj) > 0) {
                  rawUnitsToRequest.push(e)
                  this.setState({ showChart: true })
                }
              })
              arr.push(statsByExpiration[e])
            }
          })
          if (Arr.any(this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children)) {
            this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children.forEach((ch) => {
              if (e.toLowerCase().indexOf(ch.id.toLowerCase()) > -1) {
                arr.push(statsByExpiration[e])

                Object.keys(statsByExpiration[e]).map((obj) => {
                  if (Number(obj) <= 365 && Number(obj) > 0) {
                    rawUnitsToRequest.push(e)
                    this.setState({ showChart: true })
                  }
                })
              }
            })
          }
        } else {
          if (e.toLowerCase().indexOf(this.props.match?.params?.companyId?.toLowerCase()) > -1) {
            Object.keys(statsByExpiration[e]).map((el) => {
              if (Number(el) <= Number(totalExpiringFilterWithinDays) && Number(el) > 0) {
                rawUnitsToRequest.push(e)
                this.setState({ showChart: true })
              }
            })
            arr.push(statsByExpiration[e])
          }
        }
      } else {
        if (this.state.groupInFilter) {
          this.state.filteredCustomers.map((el) => {
            if (el.tenantId === this.state.groupInFilter) {
              if (e.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                Object.keys(statsByExpiration[e]).map((obj) => {
                  if (Number(obj) <= Number(totalExpiringFilterWithinDays) && Number(obj) > 0) {
                    rawUnitsToRequest.push(e)
                    this.setState({ showChart: true })
                  }
                })
                arr.push(statsByExpiration[e])
              }
            }
          })
        } else {
          arr.push(statsByExpiration[e])
        }
      }
    })
    arr.map((obj) => {
      Object.keys(obj).map(
        (el) => (
          allContracts.push(Number(el)),
          (today = new Date()),
          (today.setDate(today.getDate() + Number(el)),
          rawStats.push({
            name: today.getFullYear(),
            val: obj[el],
          }))
        )
      )
    })
    let result = false
    if (allContracts.length > 0) {
      result = true
    }

    this.setState({ showChart: result })
    rawStats.map((el) => {
      if (el.name in newStats) {
        newStats[el.name] = newStats[el.name] + el.val
      } else {
        newStats[el.name] = el.val
      }
    })
    const options = {
      maintainAspectRatio: false,
      responsive: true,
      scales: {
        x: {
          grid: {
            lineWidth: 0,
          },
        },
      },
      plugins: {
        datalabels: {
          color: 'white',
        },
        legend: {
          display: false,
        },
      },
    }
    const rawData = []
    for (const el in newStats) {
      if (el === '3000') {
        continue
      }
      expirationYears.push(Number(el))
      if (
        !!this.state.filterWithinDays &&
        this.state.filterWithinDays !== 'All' &&
        el === this.state.filterWithinDays
      ) {
        rawData.push({
          label: el,
          data: newStats[el],
        })
      }
      if (this.state.filterWithinDays === 'All') {
        rawData.push({
          label: el,
          data: newStats[el],
        })
      }
    }
    this.setState({
      expirationYears,
    })

    if (Arr.any(rawData)) {
      const labelsSorted = []
      const dataSorted = []
      rawData
        .sort((a, b) => a.label.localeCompare(b.label))
        .forEach((el) => (labelsSorted.push(el.label), dataSorted.push(el.data)))
      this.setState({
        expirationData: {
          options: options,
          data: {
            labels: labelsSorted,
            datasets: [{ label: '', data: dataSorted, backgroundColor: paletteForMakesCharts }],
          },
        },
        expirationLoading: false,
      })
    }
    if (allContracts.length > 0 && !this.state.allContractsByExpiration) {
      this.setState({
        allContractsByExpiration: allContracts.reduce((a, b) => a + b, 0),
      })
    }
    if (rawUnitsToRequest.length === 0 && downloadUnits) {
      this.setState({
        contractsToShow: null,
      })
    }
    if (rawUnitsToRequest.length > 0 && downloadUnits) {
      const test: string[] = []
      const unitsToRequest = rawUnitsToRequest.filter((v, i, a) => a.indexOf(v) === i)
      this.setState({ contractsListLoading: !this.state.contractsListLoading, showChart: true })
      this.state.filteredCustomers?.map((el) => {
        if (this.state.groupInFilter) {
          if (el?.tenantId === this.state.groupInFilter) {
            test.push(el?.id)
          }
        } else {
          test.push(el?.id)
        }
      })
      this.props.loadContractsByUnits(unitsToRequest).then((contracts) =>
        this.setState({
          contractsListLoading: false,
          contracts: {
            items: contracts,
            totalCount: contracts.length,
            customerIds: test.length > 0 ? test : new Array(companyId!),
          },
        })
      )
    }
  }
  private getStatsByVehicleMakeForPieChart() {
    this.setState({
      refreshVehicleChart: true,
    })
    const test = []
    const arr: (typeof statsByVehicleMake)[string][] = []
    const newStats: { [key: string]: number } = {}
    const { statsByVehicleMake } = this.state
    Object.keys(statsByVehicleMake).map((e) => {
      if (this.props.match?.params?.companyId?.length) {
        if (this.props.history.location.pathname.indexOf('treeview') > -1) {
          this.state.filteredCustomers.map((el) => {
            if (e.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
              arr.push(statsByVehicleMake[e])
            }
          })
          if (Arr.any(this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children)) {
            this.state.filteredCustomers[this.state.filteredCustomers.length - 1]?.children.forEach((ch) => {
              if (e.toLowerCase().indexOf(ch.id.toLowerCase()) > -1) {
                arr.push(statsByVehicleMake[e])
              }
            })
          }
        } else {
          if (e.toLowerCase().indexOf(this.props.match?.params?.companyId?.toLowerCase()) > -1) {
            arr.push(statsByVehicleMake[e])
          }
        }
      } else {
        if (this.state.groupInFilter) {
          this.state.filteredCustomers.map((el) => {
            if (el.tenantId === this.state.groupInFilter) {
              if (e.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
                arr.push(statsByVehicleMake[e])
              }
            }
          })
        } else {
          arr.push(statsByVehicleMake[e])
        }
      }
    })
    arr.map((obj) => {
      Object.keys(obj).map((el) =>
        test.push({
          name: el.charAt(0).toUpperCase() + el.slice(1).toLowerCase(),
          val: obj[el as unknown as number],
        })
      )
    })
    test.map((el) => {
      if (el.name in newStats) {
        newStats[el.name] = newStats[el.name] + el.val
      } else {
        newStats[el.name] = el.val
      }
    })
    const rawData = []
    const options = {
      maintainAspectRatio: false,
      responsive: true,
      scales: {
        x: {
          grid: {
            lineWidth: 0,
          },
          ticks: {
            maxRotation: 90,
            minRotation: 90,
          },
        },
      },
      plugins: {
        datalabels: {
          color: 'white',
        },
        legend: {
          display: false,
        },
      },
    }
    for (const el in newStats) {
      rawData.push({
        label: el,
        data: newStats[el],
      })
    }
    if (Arr.any(rawData)) {
      const dataSorted: number[] = []
      const labelsSorted: string[] = []
      rawData
        .sort((a, b) => a.label.localeCompare(b.label))
        .forEach((el) => (labelsSorted.push(el.label), dataSorted.push(el.data)))
      this.setState({
        vehicleData: {
          options: options,
          data: {
            labels: labelsSorted,
            datasets: [{ label: '', data: dataSorted, backgroundColor: paletteForMakesCharts }],
          },
        },
      })
    }
    this.setState({
      loading: false,
    })
  }
}

/**
 * decide what part of state should be exposed
 * @param state  redux state
 * @param ownProps props of component
 */
function mapStateToProps({ appData, customers, contracts }: State) {
  return {
    customers: customers.customers,
    appData,
    user: appData.currentUser,
    stats: contracts.stats,
    currentUser: appData.currentUser,
  }
}

/**
 * What action should be passed to component
 */
const mapDispatchToProps = {
  loadExpiringContracts: wrapQuery((contractsLimit: number, daysLimit: number) =>
    contractsApi.endpoints.getContracts.initiate({
      contractsLimit,
      daysLimit,
      contractFilter: ContractsFilter.ByExpiration,
    })
  ),
  loadContractsByUnits: wrapQuery((securityKeys: string[]) =>
    contractsApi.endpoints.getContractsBySecurityKeys.initiate({ securityKeys })
  ),
  getCustomersStatistics: wrapQuery(
    (grouping?: ContractsGrouping, statuses?: ContractState[], expirationDays?: number) =>
      contractsApi.endpoints.getContractStatistics.initiate({ grouping, statuses, expirationDays })
  ),
  getStatsByExpiration: wrapQuery(() =>
    contractsApi.endpoints.getContractStatistics.initiate({ grouping: ContractsGrouping.ByExpiration })
  ),
  loadTenants: wrapQuery(() => customersApi.endpoints.getTenants.initiate()),
  getOrdersForms: wrapQuery(() => ordersApi.endpoints.getOrdersForms.initiate()),
}
const connector = connect(mapStateToProps, mapDispatchToProps)
// eslint-disable-next-line react-refresh/only-export-components
export default connector(withTranslation('common')(withVehicleOrderStats(DashBoardComponent)))
